import { Component, OnInit, OnChanges, Input } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { LayoutService } from '../../services/layout.service';
import { ApiService } from 'profile';
import { PlatformService } from '../../services/platform.service';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-my-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class MyProfileComponent implements OnInit, OnChanges {
  @Input() changedLanguage: string = '';
  @Input() RightNavData: any;
  applicationID = "1";
  userprinciplename: string;
  institutionname: string = "";
  currentRoute: any;
  // feed user details variables
  username: any;
  role: any;
  email: any;
  phone: any;
  location: any;
  professionalid: any;
  logOutUrl: string;
  // feed user details variables end
  facilityAccounts


  constructor(
    private router: Router,
    private authService: AuthService,
    private layoutService: LayoutService,
    private profileApiService: ApiService,
    private platformService: PlatformService
  ) {

  }

  ngOnInit() {
    this.currentRoute = this.router.url;
    this.profileApiService.apiUrl = environment.PLATFORM_AUTH;
    this.logOutUrl = environment.Platform_URI;
    this.userprinciplename = localStorage.getItem('user_token');
    this.layoutService.getProfileData$.subscribe(res => {
      this.facilityAccounts = res.associatedAccounts;
    });
  };
  ngOnChanges() {
    //console.log(this.changedLanguage);
  }
  onEmitEvent(event) {
    if (event.event == 'loadInstitution') {
      //var facilityAccount = this.facilityAccounts.find(res=>res.facilityName == event.value);
      this.layoutService.facilityAccount.next(event.value);
    }
    if (event.event == 'logout') {
      console.log("LOGOUT EVENT");
      var postParams = {
        "expires_in": localStorage.getItem('expires_in'),
        "ext_expires_in": localStorage.getItem('ext_expires_in'),
        "access_token": localStorage.getItem('access_token'),
        "refresh_token": localStorage.getItem('refresh_token'),
        "display_name": localStorage.getItem('dispName'),
        "user_principal_name": localStorage.getItem('token'),
        "user_profile_id": localStorage.getItem('user_token'),
        "jobTitle": "",
        "sessionid": localStorage.getItem('sessionId')
      };
      this.platformService.logout(postParams).subscribe(
        (res) => {
          localStorage.clear();
          this.layoutService.changeExpandValue(true);
          window.location.href = this.logOutUrl;
        }, (err) => {
          localStorage.clear();
          this.layoutService.changeExpandValue(true);
          window.location.href = this.logOutUrl;
        });

    }
  }
}
